module.exports = __webpack_public_path__ + "static/media/RP-B_S_Fashion_Necchi_Blue_Orange.04a19ac6.png";